import { ClientConfig } from '../types/profile';

export const jetownConfig: ClientConfig = {
  id: 'client-jetown-001',
  slug: 'jetown',
  profileUrl: (import.meta as any)?.env?.VITE_PROFILE_URL || 'https://profile.jetown.net',
  defaultLocale: 'ar',
  supportedLocales: ['ar', 'en'],
  identity: {
    name: {
      ar: 'JetOwn | البوابة الرائدة لتكنولوجيا المعلومات',
      en: 'JetOwn | Leading Information Technology Gateway',
    },
    tagline: {
      ar: 'حلول التحول الرقمي، Odoo ERP، أتمتة الذكاء الاصطناعي، وأنظمة التوزيع وسلاسل التوريد',
      en: 'Digital Transformation, Odoo ERP, AI Automation, Van Sales & Supply Chain Systems',
    },
    description: {
      ar: 'شريكك الاستراتيجي في تطوير الأعمال وأتمتة العمليات الصناعية والتجارية عبر حلول برمجية متكاملة وسحابية متقدمة.',
      en: 'Your strategic partner in business development and industrial automation through integrated enterprise software and advanced cloud solutions.',
    },
    logoUrl: '/assets/jetown-logo.png',
    avatarUrl: '/assets/jetown-logo.png',
    coverUrl: '/assets/cover.jpg',
    badge: {
      ar: 'شريك تقني معتمد',
      en: 'Certified Tech Partner',
    },
    verified: true,
  },
  branding: {
    primaryColor: '#0284c7',
    primaryGlowColor: '#38bdf8',
    accentGoldColor: '#f59e0b',
    accentGreenColor: '#10b981',
    accentPurpleColor: '#8b5cf6',
    backgroundColor: '#070c18',
    cardBackgroundColor: 'rgba(15, 23, 42, 0.78)',
    borderColor: 'rgba(56, 189, 248, 0.25)',
    textColor: '#f8fafc',
    mutedTextColor: '#94a3b8',
    borderRadius: '24px',
    logoStyle: 'glow',
    logoMotion: 'glow',
    poweredByUrl: 'https://profile.jetown.net/smart-profile',
  },
  metadata: {
    title: {
      ar: 'JetOwn | الملف الرقمي الذكي',
      en: 'JetOwn | Smart Digital Profile',
    },
    description: {
      ar: 'JetOwn — حلول التحول الرقمي، Odoo ERP، أتمتة الذكاء الاصطناعي، وأنظمة التوزيع وسلاسل التوريد.',
      en: 'JetOwn — Digital Transformation, Odoo ERP, AI Automation, Van Sales & Supply Chain Systems.',
    },
    favicon: '/assets/jetown-logo.png',
    appleTouchIcon: '/assets/jetown-logo.png',
    canonicalUrl: 'https://profile.jetown.net',
    ogTitle: {
      ar: 'JetOwn | الملف الرقمي الذكي',
      en: 'JetOwn | Smart Digital Profile',
    },
    ogDescription: {
      ar: 'حلول التحول الرقمي، Odoo ERP، وأتمتة الذكاء الاصطناعي للشركات والمؤسسات.',
      en: 'Digital Transformation, Odoo ERP, and AI Automation Platform for Enterprises.',
    },
    ogImage: '/assets/jetown-logo.png',
    ogType: 'profile',
    siteName: {
      ar: 'منصة JetOwn',
      en: 'JetOwn Platform',
    },
    themeColor: '#070c18',
  },
  qr: {
    enabled: true,
    branded: true,
    logo: true,
    foreground: '#0284c7',
    background: '#ffffff',
    accent: '#38bdf8',
  },
  contacts: {
    phone: '+962796396210',
    whatsapp: '+962796396210',
    whatsappGreeting: {
      ar: 'مرحباً JetOwn، أود الاستفسار عن خدمات التحول الرقمي والأنظمة الذكية',
      en: 'Hello JetOwn, I would like to inquire about digital transformation and smart systems',
    },
    email: 'info@jetown.net',
    website: 'https://jetown.net',
    address: {
      ar: 'الأردن • عُمان • الولايات المتحدة الأمريكية',
      en: 'Jordan • Oman • United States of America',
    },
  },
  socials: [
    {
      id: 'wa',
      platform: 'whatsapp',
      url: 'https://wa.me/962796396210',
      label: { ar: 'واتساب', en: 'WhatsApp' },
    },
    {
      id: 'fb',
      platform: 'facebook',
      url: 'https://www.facebook.com/jetown.net',
      label: { ar: 'فيسبوك', en: 'Facebook' },
    },
    {
      id: 'ig',
      platform: 'instagram',
      url: 'https://www.instagram.com/jetown.net',
      label: { ar: 'انستغرام', en: 'Instagram' },
    },
    {
      id: 'yt',
      platform: 'youtube',
      url: 'https://www.youtube.com/@jetownnet',
      label: { ar: 'يوتيوب', en: 'YouTube' },
    },
    {
      id: 'li',
      platform: 'linkedin',
      url: 'https://www.linkedin.com/company/jetown',
      label: { ar: 'لينكد إن', en: 'LinkedIn' },
    },
  ],
  services: [
    {
      id: 'odoo-erp',
      title: {
        ar: 'حلول وتطبيقات Odoo ERP المتكاملة',
        en: 'Integrated Odoo ERP Solutions & Hosting',
      },
      description: {
        ar: 'تخصيص وتهيئة كاملة لإدارة المصانع، المستودعات، الحسابات، ونقاط البيع مع استضافة سحابية فائقة الأمان.',
        en: 'Customization and deployment for factory management, inventory, accounting, and POS with secure cloud hosting.',
      },
      badge: {
        ar: 'حل مؤسسي',
        en: 'Enterprise',
      },
      linkUrl: 'https://jetown.net/odoo/odoo.php',
      highlighted: true,
    },
    {
      id: 'ai-automation',
      title: {
        ar: 'أتمتة الذكاء الاصطناعي وتكامل Jet-Hermes',
        en: 'AI Automation & Jet-Hermes Integration',
      },
      description: {
        ar: 'مساعدون أذكياء لخدمة العملاء، أتمتة الردود على مدار الساعة، وربط العمليات بذكاء اصطناعي سيادي.',
        en: '24/7 intelligent customer assistance, automated responses, and sovereign AI process integration.',
      },
      badge: {
        ar: 'ذكاء اصطناعي',
        en: 'AI Powered',
      },
      linkUrl: 'https://tr.ee/fSP8Nuw4W5',
      highlighted: true,
    },
    {
      id: 'van-sales',
      title: {
        ar: 'أنظمة مبيعات الفان وسلاسل التوريد',
        en: 'Van Sales & Supply Chain Tracking Systems',
      },
      description: {
        ar: 'إدارة أساطيل التوزيع ومندوبي المبيعات والفوترة الإلكترونية اللحظية المتوافقة مع متطلبات الضريبة.',
        en: 'Fleet distribution management, mobile field sales, and real-time electronic invoicing compliance.',
      },
      badge: {
        ar: 'سلاسل التوريد',
        en: 'Logistics',
      },
      linkUrl: 'https://jetown.net',
    },
    {
      id: 'smart-profiles',
      title: {
        ar: 'البروفايلات الرقمية وبطاقات NFC الذكية',
        en: 'Smart Digital Profiles & NFC Identity Cards',
      },
      description: {
        ar: 'هويات رقمية تفاعلية متعددة اللغات مخصصة للشركات والمدراء التنفيذيين وممثلي المبيعات.',
        en: 'Multilingual interactive digital identities engineered for corporations, executives, and sales teams.',
      },
      badge: {
        ar: 'تقنية NFC',
        en: 'NFC Tech',
      },
      linkUrl: 'https://jetown.net/jp/jetown-profile.php',
    },
  ],
  features: {
    vCardDownload: true,
    qrModal: true,
    shareProfile: true,
    contactForm: true,
    aiAssistant: true,
    servicesShowcase: true,
    socialGrid: true,
    virtualTour: true,
  },
  virtualTour: {
    enabled: true,
    ecosystemUrl: 'https://jet-malls.com/',
    promotionEnabled: true,
    promotionUrl: 'https://jet-malls.com/backend/register',
    label: {
      ar: 'الجولات الافتراضية',
      en: 'Virtual Tours',
    },
    promotionLabel: {
      ar: 'أنشئ جولتك الافتراضية',
      en: 'Create Your Virtual Tour',
    },
    promotionDescription: {
      ar: 'اعرض أعمالك وتجربتك بطريقة تفاعلية 360° عبر منصة Jet-Malls المتطورة.',
      en: 'Showcase your business with an interactive 360° experience powered by Jet-Malls.',
    },
    promotionBadge: {
      ar: 'خدمة مميزة',
      en: 'Growth Feature',
    },
  },
  aiAssistant: {
    providerMode: 'AI_DISABLED',
    enabled: true,
    botName: {
      ar: 'مساعد JetOwn الذكي',
      en: 'JetOwn Smart Assistant',
    },
    welcomeMessage: {
      ar: 'مرحباً بك! أنا مساعد JetOwn الذكي. كيف يمكنني مساعدتك في استشارات التحول الرقمي وحلول Odoo اليوم؟',
      en: 'Welcome! I am JetOwn Smart Assistant. How can I assist you with digital transformation and Odoo solutions today?',
    },
    placeholder: {
      ar: 'اكتب استفسارك هنا...',
      en: 'Type your inquiry here...',
    },
  },
  footerText: {
    ar: '© 2026 JetOwn - البوابة الرائدة لتكنولوجيا المعلومات',
    en: '© 2026 JetOwn - Leading IT Gateway',
  },
  regionsText: {
    ar: 'الأردن • عُمان • الولايات المتحدة الأمريكية',
    en: 'Jordan • Oman • United States of America',
  },
};

